module.exports = function() {
  return new Worker(__webpack_public_path__ + "f04344f7b94cd8a3f1de.worker.js");
};